<template>
  <a-modal v-model="showModal" :footer="null" class="mobile-modal-fullscreen" @cancel="hide" :closable="false" :centered="true" width="587px">
    <div :style="{ display: 'flex', 'flex-direction': 'column', gap: '24px' }">
      <div>
        <div class="d-flex align-items-center padding-mobile">
          <font-awesome-icon :icon="['fal', 'times']" class="show-in-mobile mr-3 font20 gray400" @click="hide()" />
          <h1 class="title">{{ title }}</h1>
          <font-awesome-icon :style="{ 'align-self': 'center' }" :icon="['fal', 'times']" class="hide-in-mobile ml-auto font20 cp gray400" @click="hide()" />
        </div>

        <div class="post-share-circle-container">
          <div class="post-share-circle-container--item--left" :style="{ gap: '1rem' }">
            <div class="icon-container">
              <i class="fa fa-users" aria-hidden="true" :style="{ color: getPrimaryColor() }"></i>
            </div>
            <p>Share with All Circle Members</p>
          </div>
          <!-- <a-button
            :loading="loadingAll"
            :class="sendText === 'Send' && users.length ? `dove-btn font-white primary-button` : `dove-btn-2 sent-button`"
            :style="{ background: sendText === 'Send' && users.length ? getPrimaryColor() : ' #7a8ca335', border: 'none', 'border-radius': '6px' }"
            :disabled="(!isUserSearch && query == null) || sendText === 'Sent'"
            @click="users.length ? bulkShare() : null"
          >
            <div class="send-sent text-capitalize d-flex"><a-icon :class="sendText === 'Sent' ? `d-flex align-items-center mr-1` : 'd-none'" type="check" />{{ sendText }}</div>
          </a-button> -->
          <a-button
            :loading="loadingAll"
            class="br6 py-2 px-3"
            :style="{ background: sendText === 'Send' && users.length ? getPrimaryColor() : '#E2E8F0', border: 'none' }"
            :disabled="(!isUserSearch && query == null) || sendText === 'Sent'"
            @click="users.length ? bulkShare() : null"
          >
            <div :class="`font12 fw700 d-flex ${sendText === 'Sent' || !users.length ? 'gray600' : 'text-white'}`">
              <a-icon v-if="sendText === 'Sent'" class="d-flex align-items-center mr-1" type="check" />
              {{ sendText }}
            </div>
          </a-button>
        </div>
      </div>
      <form class="nosubmit d-flex align-items-center searchContainer" onSubmit="return false;">
        <font-awesome-icon :icon="['fal', 'search']" :style="{ color: getPrimaryColor() }" @click="handlefetch" class="cp pr-3 ml-3 font20" />
        <input
          :style="{ 'border-radius': '8px', background: '#F1F5F9' }"
          type="search"
          class="search-input primary-border post-share-search"
          placeholder="Search Member"
          @input="handlefetch"
          @keyup.enter="handlefetch"
          v-model="query"
          :disabled="!isUserSearch && query == null"
        />
      </form>
      <div v-if="users">
        <div class="share" v-for="user in users" :key="user.id" :style="{ border: 'none' }">
          <div class="d-flex align-items-center">
            <a-avatar :size="40" icon="user" :src="user.url" alt="" class="share-post-list-image" />
            <p class="gray800 font16 fw700 text-capitalize">{{ user.display_name || "" }}</p>
          </div>
          <!-- <a-button
            :loading="loading === user.id"
            @click="share(user)"
            :disabled="sentIds.includes(user.id) || allSend"
            :class="!sentIds.includes(user.id) ? `dove-btn font-white  primary-button` : `dove-btn-2 sent-button`"
            :style="{ background: !sentIds.includes(user.id) || allSend ? getPrimaryColor() : ' #7a8ca335', border: 'none' }"
          >
            <div class="send-sent text-capitalize d-flex">
              <a-icon :class="sentIds.includes(user.id) || allSend ? `d-flex align-items-center mr-1` : 'd-none'" type="check" />{{ sentIds.includes(user.id) || allSend ? "Sent" : "Send" }}
            </div>
          </a-button> -->
          <a-button
            :loading="loading === `${user.id}${user.role}`"
            @click="share(user)"
            class="br6 py-2 px-3"
            :disabled="(sentUsers[user.id] && sentUsers[user.id].includes(user.role)) || allSend"
            :style="{ background: !(sentUsers[user.id] && sentUsers[user.id].includes(user.role)) && !allSend ? getPrimaryColor() : '#E2E8F0', border: 'none' }"
          >
            <!-- :style="{ background: !sentIds.includes(user.id) && !allSend ? getPrimaryColor() : '#E2E8F0', border: 'none' }" -->
            <!-- :disabled="sentIds.includes(user.id) || allSend" -->
            <!-- :loading="loading === user.id" -->
            <div :class="`font12 fw700 d-flex ${(sentUsers[user.id] && sentUsers[user.id].includes(user.role)) || allSend ? 'gray600' : 'text-white'}`">
              <a-icon v-if="(sentUsers[user.id] && sentUsers[user.id].includes(user.role)) || allSend" class="d-flex align-items-center mr-1" type="check" />
              {{ (sentUsers[user.id] && sentUsers[user.id].includes(user.role)) || allSend ? "Sent" : "Send" }}
            </div>
            <!-- <div :class="`font12 fw700 d-flex ${sentIds.includes(user.id) || allSend ? 'gray600' : 'text-white'}`">
              <a-icon v-if="sentIds.includes(user.id) || allSend" class="d-flex align-items-center mr-1" type="check" />{{ sentIds.includes(user.id) || allSend ? "Sent" : "Send" }}
            </div> -->
          </a-button>
        </div>
      </div>
      <div v-if="loadingData" class="d-flex justify-content-center mt-3">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading...</div>
      </div>
      <div v-if="!isUserSearch && !loadingData && query != null" class="not-found">No members found under that name.</div>
      <div
        v-if="!isUserSearch && !loadingData && query === null"
        class="not-found"
      >
        <span class="dailog">No one added yet</span>
        <span class="sub-dailog"
          >You have not added anyone to your circle yet.</span
        >
        <a-button
          :style="{
            background: getSecondaryColor(),
            'pointer-events': 'all',
            'font-size': '14px',
            'border-radius': '6px',
            padding: '12px 24px'
          }"
          class="font-white primary-button profile-btn mt-2"
          @click="() => $router.push({ name: 'MeetOthers' })"
        >
          Search and Add
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory"

const AppRepository = RepositoryFactory.get("app")
const PostRepository = RepositoryFactory.get("posts")

export default {
  name: "SharePost",
  data() {
    return {
      allSend: false,
      showModal: false,
      user: null,
      currentPage: 1,
      limit: 50,
      users: [],
      timeout: null,
      pagination: null,
      query: null,
      entityData: null,
      entityType: null,
      loadingAll: false,
      loading: false,
      loadingData: false,
      title: "",
      sendText: "Send",
      sentIds: [],
      sentUsers: {},
      userIds: [],
      usersObj: {},
      isUserSearch: false,
    }
  },
  // created() {},
  // mounted() {
  //   setTimeout(() => {
  //     if (document.getElementsByClassName("ant-modal-header")) {
  //       document.getElementsByClassName("ant-modal-header")[0].setAttribute("style", `background: ${this.getPrimaryColor()}; color: ${this.getPrimaryColor()}`)
  //       if (document.getElementsByClassName("ant-modal-header")[0].children) {
  //         document.getElementsByClassName("ant-modal-header")[0].children[0].setAttribute("style", `color: #fff !important`)
  //       }
  //     }
  //     if (document.getElementsByClassName("anticon-close")) {
  //       document.getElementsByClassName("anticon-close")[0].children[0].setAttribute("fill", `#fff`)
  //     }
  //   }, 100)
  // },
  methods: {
    show(data, type, title = "Share Post") {
      this.title = title
      this.entityData = data
      this.entityType = type
      this.fetch()
      this.showModal = true
      // setTimeout(() => {
      //   if (document.getElementsByClassName("ant-modal-header")) {
      //     document.getElementsByClassName("ant-modal-header")[0].setAttribute("style", `background: ${this.getPrimaryColor()}; color: ${this.getPrimaryColor()}`)
      //     if (document.getElementsByClassName("ant-modal-header")[0].children) {
      //       document.getElementsByClassName("ant-modal-header")[0].children[0].setAttribute("style", `color: #fff !important`)
      //     }
      //   }
      //   if (document.getElementsByClassName("anticon-close")) {
      //     document.getElementsByClassName("anticon-close")[0].children[0].setAttribute("fill", `#fff`)
      //   }
      // }, 100)
    },
    hide() {
      this.showModal = false
      this.query = null
    },
    fetch() {
      this.loadingData = true
      const params = {}
      params.page_num = this.currentPage
      params.items = this.limit
      params.circle_id = this.currentCircle.id
      params.username = this.query
      AppRepository.shareSearch(params).then(res => {
        this.users = res.data.data ? res.data.data : []
        if (this.users.length) {
          // this.users.map(user => {
          //   this.userIds.push(user.id)
          // })
          this.users.forEach(user => {
            if (this.usersObj[user.id]) {
              this.usersObj[user.id].push(user.role)
            } else {
              this.usersObj[user.id] = [user.role]
            }
          })
        }
        this.loadingData = false
        this.isUserSearch = this.users.length ? true : false
      })
    },

    handlefetch() {
      clearTimeout(this.timeout)
      var self = this
      this.timeout = setTimeout(function() {
        self.fetch()
      }, 500)
    },

    bulkShare() {
      this.loadingAll = true
      const userList = this.users.map(user => ({ user: user.id, role: user.role }))
      const payload = { reacted_on_type: this.entityType, reacted_on_id: this.entityData.id, user: userList, reaction_type: 6 }
      PostRepository.bulkShare(this.currentCircle.id, payload)
        .then(res => {
          this.loadingAll = false
          this.notify("success", "Success", "Successfully shared with all circle members")
          this.sendText = "Sent"
          this.allSend = true
        })
        .catch(err => {
          this.allSend = false
          this.sendText = "Send"
          this.loadingAll = false
        })
    },

    share(user) {
      this.loading = `${user.id}${user.role}`
      const payload = { reacted_on_type: this.entityType, reacted_on_id: this.entityData.id, user: user.id, reaction_type: 6, user_role: user.role }
      PostRepository.saveReaction(this.currentCircle.id, payload)
        .then(res => {
          if (this.sentUsers[user.id]) {
            this.sentUsers[user.id].push(user.role)
          } else {
            this.sentUsers[user.id] = [user.role]
          }
          this.sentIds.push(user.id)
          this.loading = false
          this.notify("success", "Success", "Shared successfully")
          if (_.isEqual(this.sentUsers, this.usersObj)) {
            this.sendText = "Sent"
          }
        })
        .catch(err => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.padding-mobile {
  padding-bottom: 24px;
}
.title {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #33415f;
}
.searchContainer {
  background: #f1f5f9;
  height: 44px;
  border-radius: 8px;
}
.icon-container {
  background: #e2e8f0;
  border: 1px solid #f8fafd;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  display: flex;
}
.share-post-list-image {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  margin-right: 10px;
}
p {
  margin: 0;
  font-size: 18px;
}
.share {
  display: flex;
  margin-bottom: 16px;
  padding: 8px;
  justify-content: space-between;
  align-items: center;
}

.post-share-circle-container {
  display: flex;
  padding: 8px;
  gap: 16px;
  justify-content: space-between;
  @media screen and (max-width: 900px) {
    // padding: 20px 15px;
  }
  p {
    margin: 0;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    text-transform: capitalize;
    color: #1e2945;
    @media screen and (max-width: 900px) {
      font-size: 16px;
    }
    i {
      font-size: 40px;
      vertical-align: middle;
      margin-right: 15px;
    }
  }
  &--item--left {
    display: flex;
    align-items: center;
  }
}
.post-share-search {
  width: 100%;
  height: 44px;
  border: none !important ;
  background: #f1f5f9;
  padding: 15px 10px;
  &:focus {
    outline: none;
  }
}

.dove-btn {
  padding: 8px 16px;
  font-weight: 700;
  font-size: 12px;
  border-radius: 6px;

  &-2 {
    padding: 8px 21px;
    font-size: 14px;
    border-radius: 20px;
    margin-right: 10px;
  }
}

.send-sent {
  font-size: 14px;
}
@media screen and (max-width: 581px) {
  .send-sent {
    font-size: 12px;
  }

  .padding-mobile {
    gap: 16px;
  }
}

.not-found {
  background: #f2f4f6;
  // border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  padding: 16px 24px;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .sub-dailog {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: #33415f;
  }
  .dailog {
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    color: #0f1734;
  }
}
.sent-button {
  line-height: 20px;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  border-radius: 4px;
  color: #47556e !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/SharePost.vue